import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  formAccDisclaimer: {
    id: 'formAccDisclaimer',
    defaultMessage:
      'Account changes will be applied to all actors with this template.',
  },
  addFormAcc: {
    id: 'addFormAcc',
    defaultMessage: 'Add account',
  },
  removeFormAcc: {
    id: 'removeFormAcc',
    defaultMessage: 'Remove account',
  },
  formAccCreateCurrency: {
    id: 'formAccCreateCurrency',
    defaultMessage: 'Create new currency',
  },
  formAccEnterCurrencyName: {
    id: 'formAccEnterCurrencyName',
    defaultMessage: 'Сurrency name',
  },
  formAccSelectName: {
    id: 'formAccSelectName',
    defaultMessage: 'Select account name',
  },
  formAccСreateName: {
    id: 'formAccСreateName',
    defaultMessage: 'Create new account',
  },
  formAccEnterName: {
    id: 'formAccEnterName',
    defaultMessage: 'Account name',
  },
  formAccSelectCurrency: {
    id: 'formAccSelectCurrency',
    defaultMessage: 'Select currency',
  },
  formAccSelectOrCreateCurrency: {
    id: 'formAccSelectOrCreateCurrency',
    defaultMessage: 'Please select accounts currency or create new currency',
  },
  formAccSelectOrCreateName: {
    id: 'formAccSelectOrCreateName',
    defaultMessage: 'Please select account name or create a new',
  },
  formAccNotFound: {
    id: 'formAccNotFound',
    defaultMessage: 'Not Found',
  },
});

export default { ...globalIntl, ...m };
